import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { COMPANY, waLink } from "@/lib/constants";

export const FloatingCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Floating WhatsApp — always visible */}
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Falar no WhatsApp"
        className="fixed bottom-24 right-5 md:bottom-6 md:right-6 z-50 bg-[#25d366] hover:bg-[#1ebe56] text-white w-16 h-16 rounded-full flex items-center justify-center pulse-green shadow-xl transition-all duration-300 hover:scale-110"
      >
        <i className="fa-brands fa-whatsapp text-3xl" aria-hidden></i>
      </a>

      {/* Mobile bottom bar */}
      <div
        data-testid="mobile-cta-bar"
        className={`md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0a0a0a]/95 backdrop-blur-md border-t border-[#2d3748] p-3 transition-transform duration-300 ${
          show ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="flex gap-2">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-bar-whatsapp"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#25d366] hover:bg-[#1ebe56] text-white font-display uppercase tracking-wider font-bold py-3 rounded-full text-sm"
          >
            <i className="fa-brands fa-whatsapp text-lg" aria-hidden></i>
            WhatsApp
          </a>
          <a
            href={`tel:${COMPANY.phoneTel}`}
            data-testid="mobile-bar-phone"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#d90429] hover:bg-[#ef233c] text-white font-display uppercase tracking-wider font-bold py-3 rounded-full text-sm"
          >
            <Phone className="w-4 h-4" />
            Ligar
          </a>
        </div>
      </div>
    </>
  );
};
